export const GOP_SUPPORTED_COUNTRIES = ['US']
